var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPriaErrorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3315 6.44071C31.3315 6.44071 33.1831 4.83767 35.449 4.55945C35.449 4.55945 36.1429 4.89958 36.9442 7.40501C37.7455 9.91044 36.2663 14.8594 36.2663 14.8594L31.3323 6.44071H31.3315Z",
    fill: "url(#paint0_linear_965_1918)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4491 4.5595C35.4491 4.5595 33.6157 6.53107 33.6157 9.70948L34.3248 10.1581L36.3905 5.8683C36.3905 5.8683 35.7053 4.52163 35.4498 4.5595H35.4491Z",
    fill: "url(#paint1_linear_965_1918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2574 9.94103C34.2574 9.94103 33.7697 7.22657 35.5501 5.23169C35.5501 5.23169 37.5613 6.18288 38.3938 9.70869C39.2263 13.2345 37.0597 15.3517 37.0597 15.3517L34.2581 9.94103H34.2574Z",
    fill: "#3CCBDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7984 6.84208C15.7984 6.84208 13.9469 5.23904 11.6809 4.96082C11.6809 4.96082 10.987 5.30094 10.1857 7.80638C9.38443 10.3118 10.8636 15.2608 10.8636 15.2608L15.7977 6.84208H15.7984Z",
    fill: "url(#paint2_linear_965_1918)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6809 4.96075C11.6809 4.96075 13.515 6.93232 13.515 10.1107L12.8059 10.5594L10.7402 6.26954C10.7402 6.26954 11.4254 4.92287 11.6809 4.96075Z",
    fill: "url(#paint3_linear_965_1918)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8734 10.3431C12.8734 10.3431 13.3612 7.62867 11.5808 5.63379C11.5808 5.63379 9.56957 6.58498 8.73707 10.1108C7.90457 13.6366 10.3034 15.9818 10.3034 15.9818L12.8727 10.3424L12.8734 10.3431Z",
    fill: "#3CCBDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5968 24.0094C13.4325 30.5745 34.6594 28.5272 37.1954 23.1347C39.9694 17.236 33.5911 2.65856 23.4196 3.33881C14.8261 3.91346 6.95105 15.5703 10.5968 24.0094Z",
    fill: "url(#paint4_linear_965_1918)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7683 23.083C14.4807 28.4675 33.009 27.5782 35.7163 22.6278C38.0149 18.4239 32.5866 5.62435 23.2774 6.081C13.969 6.53766 9.16485 17.9155 11.7683 23.083Z",
    fill: "#0147BA"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M15.0349 11.4734C14.8223 12.756 17.2436 12.6096 21.1165 12.4814C25.7711 12.327 30.4474 16.3481 33.1692 13.4618C33.6178 12.9862 29.1613 6.74224 23.7831 6.88207C18.4041 7.02191 15.22 10.3598 15.0349 11.4734Z",
    fill: "url(#paint5_linear_965_1918)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M12.6824 26.2235C12.6824 26.2235 12.9691 25.9125 14.5063 25.0057C15.5377 24.3976 16.6192 23.678 16.773 23.4151C17.0017 22.7938 12.3601 23.1601 12.3601 23.1601L10.5957 24.0094C10.5957 24.0094 11.2968 25.3997 12.6817 26.2235H12.6824Z",
    fill: "url(#paint6_linear_965_1918)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13632 12.4917C9.13632 12.4917 10.3339 13.2652 9.54858 15.0561C9.54858 15.0561 3.95479 18.1129 4.2785 21.4443C4.5485 24.2243 12.2776 22.8783 12.2776 22.8783L12.5549 23.8062C12.5549 23.8062 5.98922 25.0953 3.72398 23.5462C3.72398 23.5462 2.95318 21.7101 4.86422 18.4006C6.77527 15.0911 9.13632 12.4917 9.13632 12.4917Z",
    fill: "url(#paint7_linear_965_1918)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.299 22.6212C10.595 23.4209 12.0894 24.2956 13.3182 24.4296C14.6973 24.5804 17.1461 24.0327 16.9981 22.6394C16.85 21.2461 12.9503 20.7472 11.299 22.6212Z",
    fill: "#9979DB"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3924 22.7683C11.3503 22.9963 16.272 23.0509 16.3881 22.1784C16.5035 21.3058 11.7161 21.0058 11.3924 22.7683Z",
    fill: "#8666DD"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M37.182 6.82389C37.182 6.82389 36.5295 6.01327 35.6411 6.22885C34.752 6.44444 34.6932 9.25431 35.2252 9.32423C35.7573 9.39415 35.9823 7.76998 36.3902 7.51507C36.7973 7.26016 37.5101 7.35921 37.5101 7.35921L37.1827 6.82462L37.182 6.82389Z",
    fill: "url(#paint8_linear_965_1918)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.72,
    d: "M9.4834 8.02268C9.4834 8.02268 9.82671 7.6323 10.5968 7.75902C11.3676 7.88575 11.8118 9.47204 12.2059 9.31327C12.6 9.15376 12.3111 6.58278 11.2689 5.82678C11.2689 5.82678 9.92541 6.97753 9.4834 8.02268Z",
    fill: "url(#paint9_linear_965_1918)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06201 14.295C8.06201 14.295 5.38741 17.4123 5.55652 17.6286C5.72636 17.8449 8.23039 14.6097 8.06201 14.295Z",
    fill: "url(#paint10_linear_965_1918)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13L21 17",
    stroke: "#3CCBDA",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13L17 17",
    stroke: "#3CCBDA",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13L30 17",
    stroke: "#3CCBDA",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30 13L26 17",
    stroke: "#3CCBDA",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2504 22.9999C18.2531 22.799 20.3373 18.9999 23.6827 18.9999C26.651 18.9999 28.8259 22.7077 27.9476 22.9999C27.5715 23.1251 25.7906 21.3423 23.3145 21.3423C20.8384 21.3423 19.6688 23.0838 19.2504 22.9999Z",
    fill: "#2F95CD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_965_1918",
    x1: 34.2573,
    y1: 14.8594,
    x2: 34.2573,
    y2: 4.55945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_965_1918",
    x1: 35.0027,
    y1: 10.1581,
    x2: 35.0027,
    y2: 4.55877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_965_1918",
    x1: 12.8727,
    y1: 15.2608,
    x2: 12.8727,
    y2: 4.96082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9ACF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1D1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_965_1918",
    x1: 12.1273,
    y1: 10.5594,
    x2: 12.1273,
    y2: 4.96002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_965_1918",
    x1: 22.6459,
    y1: 28.4602,
    x2: 25.7977,
    y2: 3.44858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_965_1918",
    x1: 15.0226,
    y1: 10.6934,
    x2: 33.2004,
    y2: 10.6934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A9BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_965_1918",
    x1: 13.6891,
    y1: 26.2235,
    x2: 13.6891,
    y2: 23.0523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DA4E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#755CBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_965_1918",
    x1: 7.8756,
    y1: 24.4719,
    x2: 9.38171,
    y2: 12.5229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BE9DEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E8CEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_965_1918",
    x1: 34.8848,
    y1: 7.75906,
    x2: 37.5094,
    y2: 7.75906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_965_1918",
    x1: 9.4834,
    y1: 7.57549,
    x2: 12.375,
    y2: 7.57549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_965_1918",
    x1: 6.80999,
    y1: 17.6388,
    x2: 6.80999,
    y2: 14.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8DCF7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriaErrorIcon);
export default __webpack_public_path__ + "static/media/pria-error-icon.d831c827f16e6cd89a32cab6d8bb05fe.svg";
export { ForwardRef as ReactComponent };